import { createContext, useContext, Dispatch } from 'react';

import { initialState } from './reducer';
import { ActionType, StateType } from './types';

type StoreType = {
  state: StateType;
  dispatch: Dispatch<ActionType>;
};

export const CreateAccountContext = createContext<StoreType>({
  state: initialState,
  dispatch: () => {},
});

export const useCreateAccountContext = (): StoreType => useContext(CreateAccountContext);
